import {Pipe, PipeTransform} from "@angular/core";
import {PortalService} from "../services/portal.service";

/**
 * Pipe for adding advisor images to advisor components.
 *
 * @example <img [src]="advisorImagePath | advisorImageUrl"></img>
 */

@Pipe({
    name: 'advisorImageUrl',
    standalone: false
})

export class AdvisorImageUrlPipe implements PipeTransform {

  constructor(protected portalService: PortalService) {
  }

  transform(imagePath: string): any {

    return '/advisorimage/' + this.portalService.currentPortalId + imagePath;
  }
}
